import React from 'react';

function MasterCardIcon() {
  return (
    <svg width="42" height="26" viewBox="0 0 42 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.847 22.3704C18.6658 24.236 15.8366 25.3622 12.745 25.3622C5.84664 25.3622 0.254395 19.755 0.254395 12.8381C0.254395 5.92125 5.84664 0.314041 12.745 0.314041C15.8367 0.314041 18.666 1.44032 20.8472 3.306C23.0283 1.44044 25.8575 0.314242 28.9491 0.314242C35.8475 0.314242 41.4397 5.92146 41.4397 12.8383C41.4397 19.7552 35.8475 25.3624 28.9491 25.3624C25.8574 25.3624 23.0281 24.2361 20.847 22.3704Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8472 22.3705C23.5328 20.0734 25.2358 16.6552 25.2358 12.8383C25.2358 9.02136 23.5328 5.60322 20.8472 3.30608C23.0283 1.44047 25.8576 0.31424 28.9492 0.31424C35.8476 0.31424 41.4398 5.92145 41.4398 12.8383C41.4398 19.7551 35.8476 25.3624 28.9492 25.3624C25.8576 25.3624 23.0283 24.2361 20.8472 22.3705Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4143 22.3701C23.0611 20.0729 24.7393 16.6548 24.7393 12.8378C24.7393 9.02089 23.0611 5.60275 20.4143 3.30561C17.7676 5.60275 16.0894 9.02089 16.0894 12.8378C16.0894 16.6548 17.7676 20.0729 20.4143 22.3701Z"
        fill="#FF5E00"
      />
    </svg>
  );
}

export default MasterCardIcon;
